import { Formik } from "formik";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import {
    colorPaletteBlue600,
    textNeutralTertiary,
} from "../../core/theme";
import Modal from "../components/Modal";
import { Spacer } from "../components/Spacer";
import { PrimaryButton } from "../components/CustomButton";
import CustomSelect from "../components/CustomSelect";
import { GermanAccountingModel, TrSettlementModel } from "../../requests_cm/gecoContractsService/types";
const style = {
    container: {
        width: "580px",
        paddingLeft: "24px",
        paddingRight: "24px",
        paddingBottom: "24px",
    },
    titleIcon: {
        color: colorPaletteBlue600,
    },
    description: {
        color: textNeutralTertiary,
        fontSize: 20,
        fontWeight: 400,
        fontFamily: "Lato",
    },
    inputsContainer: {
        gap: "40px",
        display: "flex",
    },
};

export interface GenerateCurtailmentObjectsFromContractperiodProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: ({
        accounting_model,
        create_ch51,
        tr_settlement_model
    }: {
        accounting_model: GermanAccountingModel;
        create_ch51: boolean;
        tr_settlement_model: TrSettlementModel;
    }) => void;
}

export const GenerateCurtailmentObjectsFromContractperiod = ({
    isOpen,
    onClose,
    onSubmit,
}: GenerateCurtailmentObjectsFromContractperiodProps) => {
    return (
        <Formik
            enableReinitialize
            initialValues={{
                create_ch51: false,
                accounting_model: GermanAccountingModel.PROGNOSEMODELL,
                tr_settlement_model: TrSettlementModel.PAUSCHAL,
            }}
            onSubmit={({  tr_settlement_model, create_ch51,accounting_model }) =>
                onSubmit({
                    tr_settlement_model,
                    accounting_model,
                    create_ch51: create_ch51 ,
                })
            }
        >
            {({ handleChange, submitForm, resetForm, values, setFieldValue }) => (
                <Modal
                    open={isOpen}
                    onClose={onClose}
                    title={"Generate Curtailment Objects"}
                    sx={style.container}
                    icon={
                        <span style={style.titleIcon}>
                            <AddCircleOutlineOutlinedIcon />
                        </span>
                    }
                    actions={
                        <>
                            <PrimaryButton
                                onClick={() => {
                                    onClose();
                                    resetForm();
                                }}
                                text="Cancel"
                                type="button"
                                color="secondary"
                            />
                            <PrimaryButton
                                onClick={() => {
                                    submitForm();
                                }}
                                text="Generate"
                                type="button"
                                color="primary"
                                startIcon={<AddCircleOutlineOutlinedIcon />}
                            />
                        </>
                    }
                >
                    <Box sx={style.description}>
                        Please specify the accounting model and the TR Settlment model
                    </Box>
                    <Spacer gap={32} />
                    <Box sx={style.inputsContainer}>
                       <CustomSelect
						datatestId="tr_settlement_model"
						name="tr_settlement_model"
						label="TR settlement model"
						value={values.tr_settlement_model ?? ""}
						onChange={handleChange}
						touched={true}
						items={Object.values(TrSettlementModel).map((val) => ({
							key: val,
							value: val,
							label: val,
						}))}
					/>
                    </Box>
                    <Spacer gap={32} />
                    <Box sx={style.inputsContainer}>
                       <CustomSelect
						datatestId="accounting_model"
						name="accounting_model"
						label="Accounting model"
						value={values.accounting_model ?? ""}
						onChange={handleChange}
						touched={true}
						items={Object.values(GermanAccountingModel).map((val) => ({
							key: val,
							value: val,
							label: val,
						}))}
					/>
                    </Box>
                    <Spacer gap={32} />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={values.create_ch51}
                                onChange={(_, checked) => setFieldValue("create_ch51", checked)}
                                name="create_ch51"
                                color="primary"
                            />
                        }
                        label="Generate Chapter51 if applicable"
                    />
                </Modal>
            )}
        </Formik>
    );
};
